import {
  AttendanceMonthlySummary,
  AttendanceYearlyPoint,
  SubjectGrade,
  TimetablePeriod,
  UpcomingItem,
} from "./types";

// ---- Placeholder data ----
// None of these four domains have a student-scoped read API yet (see the
// dashboard investigation notes). Everything below is intentionally empty so
// the shipped dashboard shows honest empty states (badged via
// PlaceholderBadge) instead of fabricated numbers, and can be swapped for a
// real hook one domain at a time without touching the components.

export const attendanceMonthly: AttendanceMonthlySummary = {
  present: 0,
  absent: 0,
  leave: 0,
};

export const attendanceYearly: AttendanceYearlyPoint[] = [];

export const subjectGrades: SubjectGrade[] = [];

export const classAverageScore: number | null = null;

export const todayTimetable: TimetablePeriod[] = [];

export const upcomingItems: UpcomingItem[] = [];
